/**
 * Página de Política de Cookies
 * 
 * Esta página muestra la información sobre el uso de cookies
 * y tecnologías similares en Liga ProKids.
 */

const Cookies = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '50px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="container"
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '15px',
              color: '#061156',
              lineHeight: '1.2',
            }}
          >
            🍪 Política de Cookies
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              marginBottom: '0',
              color: '#061156',
              lineHeight: '1.6',
              maxWidth: '800px',
            }}
          >
            Información sobre el uso de cookies y tecnologías similares en nuestro sitio web.
          </p>
        </div>
      </section>

      {/* Contenido de Política de Cookies */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '1000px',
              margin: '0 auto',
              lineHeight: '1.8',
            }}
          >
            {/* Información sobre cookies */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                INFORMACIÓN SOBRE COOKIES
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                Conforme con la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información 
                y de comercio electrónico (LSSI), en relación con el Reglamento (UE) 2016/679 del Parlamento 
                Europeo y del Consejo, de 27 de abril de 2016, General de Protección de Datos (GDPR) y la 
                Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos y Garantía de los Derechos 
                Digitales (LOPDGDD), es obligado obtener el consentimiento expreso del usuario de todas las 
                páginas web que usan cookies prescindibles, antes de que este navegue por ellas.
              </p>
            </div>

            {/* ¿Qué son las cookies? */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                ¿QUÉ SON LAS COOKIES?
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                Las cookies y otras tecnologías similares tales como local shared objects, flash cookies 
                o píxeles, son herramientas empleadas por los servidores Web para almacenar y recuperar 
                información acerca de sus visitantes, así como para ofrecer un correcto funcionamiento del sitio.
              </p>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                Mediante el uso de estos dispositivos se permite al servidor Web recordar algunos datos 
                concernientes al usuario, como sus preferencias para la visualización de las páginas de 
                ese servidor, nombre y contraseña, productos que más le interesan, etc.
              </p>
            </div>

            {/* Cookies afectadas por la normativa */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS
              </h2>
              <ul style={{ paddingLeft: '20px', marginBottom: '20px' }}>
                <li style={{ marginBottom: '15px', fontSize: '1.1rem' }}>
                  Según la directiva de la UE, las cookies que requieren el consentimiento informado por 
                  parte del usuario son las cookies de analítica y las de publicidad y afiliación, quedando 
                  exceptuadas las de carácter técnico y las necesarias para el funcionamiento del sitio web 
                  o la prestación de servicios expresamente solicitados por el usuario.
                </li>
              </ul>
            </div>

            {/* Tipos de cookies */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                TIPOS DE COOKIES
              </h2>

              {/* Según la finalidad */}
              <div style={{ marginBottom: '40px' }}>
                <h3
                  style={{
                    fontSize: '1.6rem',
                    fontWeight: '600',
                    marginBottom: '20px',
                    color: '#4352A9',
                  }}
                >
                  SEGÚN LA FINALIDAD
                </h3>
                
                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies técnicas y funcionales:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son aquellas que permiten al usuario la navegación a través de una página web, plataforma 
                    o aplicación y la utilización de las diferentes opciones o servicios que en ella existan.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies analíticas:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del 
                    comportamiento de los usuarios de los sitios web a los que están vinculadas. La información 
                    recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los 
                    sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de 
                    los usuarios de dichos sitios, aplicaciones y plataformas, con el fin de introducir mejoras 
                    en función del análisis de los datos de uso que hacen los usuarios del servicio.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies publicitarias:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios
                    publicitarios que, en su caso, el editor haya incluido en una página web, aplicación o
                    plataforma desde la que presta el servicio solicitado en base a criterios como el contenido
                    editado o la frecuencia en la que se muestran los anuncios.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies de publicidad comportamental:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Recogen información sobre las preferencias y elecciones personales del usuario (retargeting)
                    para permitir la gestión, de la forma más eficaz posible, de los espacios publicitarios.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies sociales:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son establecidas por las plataformas de redes sociales en los servicios para permitirle
                    compartir contenido con sus amigos y redes.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies de seguridad:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Almacenan información cifrada para evitar que los datos guardados en ellas sean vulnerables
                    a ataques maliciosos de terceros.
                  </p>
                </div>
              </div>

              {/* Según la propiedad */}
              <div style={{ marginBottom: '40px' }}>
                <h3
                  style={{
                    fontSize: '1.6rem',
                    fontWeight: '600',
                    marginBottom: '20px',
                    color: '#4352A9',
                  }}
                >
                  SEGÚN LA PROPIEDAD
                </h3>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies propias:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio
                    gestionado por el propio editor.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies de terceros:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que
                    no es gestionado por el editor, sino por otra entidad.
                  </p>
                </div>
              </div>

              {/* Según el plazo de conservación */}
              <div style={{ marginBottom: '40px' }}>
                <h3
                  style={{
                    fontSize: '1.6rem',
                    fontWeight: '600',
                    marginBottom: '20px',
                    color: '#4352A9',
                  }}
                >
                  SEGÚN EL PLAZO DE CONSERVACIÓN
                </h3>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies de sesión:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son un tipo de cookies diseñadas para recabar y almacenar datos mientras el usuario
                    accede a una página web.
                  </p>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', marginBottom: '10px', color: '#333' }}>
                    Cookies persistentes:
                  </h4>
                  <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '15px', textAlign: 'justify' }}>
                    Son un tipo de cookies en el que los datos siguen almacenados en el terminal y pueden
                    ser accedidos y tratados durante un período definido por el responsable de la cookie.
                  </p>
                </div>
              </div>
            </div>

            {/* Tratamiento de datos personales */}
            <div style={{ marginBottom: '50px' }}>
              <h2
                style={{
                  fontSize: '2rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                TRATAMIENTO DE DATOS PERSONALES
              </h2>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                AP8 Soccer Specialists, S.L. es el Responsable del tratamiento de los datos personales del
                Interesado y le informa de que estos datos serán tratados de conformidad con lo dispuesto
                en el Reglamento (UE) 2016/679, de 27 de abril de 2016 (GDPR).
              </p>

              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                  fontWeight: '600',
                }}
              >
                Datos de contacto para ejercer sus derechos:
              </p>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  marginBottom: '20px',
                  textAlign: 'justify',
                }}
              >
                AP8 Soccer Specialists, S.L. Calle Madre Elísea Oliver, 1 – 03550 Sant Joan d&apos;Alacant (Alacant).
                E-mail: contacto@ligaprokids.es
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Contacto */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          textAlign: 'center',
        }}
      >
        <div className="container" style={containerStyle}>
          <h2
            style={{
              fontSize: '2rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#061156',
            }}
          >
            ¿Tienes alguna consulta sobre cookies?
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '30px',
            }}
          >
            Si tienes alguna pregunta sobre el uso de cookies en nuestro sitio web, 
            no dudes en contactarnos.
          </p>
          <a
            href="/contact"
            style={{
              display: 'inline-block',
              padding: '15px 40px',
              backgroundColor: '#4352A9',
              color: 'white',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1.1rem',
              textDecoration: 'none',
              border: '2px solid #4352A9',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(67, 82, 169, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#4352A9';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#4352A9';
              e.target.style.color = 'white';
            }}
          >
            Contactar
          </a>
        </div>
      </section>
    </>
  );
};

export default Cookies;
